import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import { ActionInterface } from "../../Interface/ActionInterface";
import Token from "../../Token/Token";
import Auth from "../../Auth/Auth";

export default function* unsubscribeContractEmail(action: ActionInterface): any {
  try {
    yield put({
      type: Constants.PAGE_CONTRACT_EMAIL_UNSUBSCRIBE_REQUEST
    });

    if (action.payload?.token) {
      yield call(() => Token.set(action.payload?.token));
    }

    yield call(Http.post, `contracts/unsubscribe`);

    yield put({
      type: Constants.PAGE_CONTRACT_EMAIL_UNSUBSCRIBE_SUCCESS
    });

    yield call(Auth.signout);

    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this);
    }
  } catch (err) {
    yield call(Auth.signout);

    yield ErrorHandlerSequence(err, action);

    yield put({
      type: Constants.PAGE_CONTRACT_EMAIL_UNSUBSCRIBE_FAILURE,
      payload: {
        err: err
      }
    });
  }
}

export function* watchUnsubscribeContractEmail() {
  yield takeEvery(Constants.PAGE_CONTRACT_EMAIL_UNSUBSCRIBE_START, unsubscribeContractEmail);
}
